import type { ReactNode } from 'react'

import { useT, type StringId } from '../lib/i18n'
import { ShellHeader } from '../ui/ShellHeader'

interface ScreenProps {
  /** A dictionary key, not a string: the route table must not carry copy (SUAP-0110). */
  titleKey: StringId
  children?: ReactNode
}

/**
 * Placeholder screen content. SUAP-0104 ships the shell, not the screens — each
 * one arrives with the epic that owns its data. This exists so the structure has
 * something to hold.
 *
 * There is deliberately no filler content here. An earlier version shipped 30
 * dummy rows into `/diary` so the scroll container could be proven; a review
 * pointed out that leaves unowned junk in a product route. The proof injects its
 * own content at runtime instead — see the SUAP-0104 entry in
 * `docs/coverage/EPIC-01.md`.
 */
export function Screen({ titleKey, children }: ScreenProps) {
  const { t } = useT()

  return (
    <>
      {/* Fills the shell's header slot, which sits above <main> and therefore
          does not scroll away with the content. */}
      <ShellHeader>
        <h1 className="text-lg font-semibold text-ink">{t(titleKey)}</h1>
      </ShellHeader>
      <section className="flex flex-col gap-3 p-4">
        {children ?? <p className="text-ink-soft">{t('state.comingSoon')}</p>}
      </section>
    </>
  )
}
